import http from "@/tools/http";

export default {
  getAll(orgUUID) {
    return http.get(`/organizations/${orgUUID}/credits`);
  },
  getExtract(orgUUID, queryParams) {
    return http.get(`/organizations/${orgUUID}/credits/statement`, { params: queryParams });
  },
  getHasCredits(orgUUID) {
    return http.get(`/organizations/${orgUUID}/credits/has-credits`);
  },
};
